// Generated file : do not modify
import ChatItem from '@/extend/classes/ChatItem';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Fils de discussion
export default class Chat  {
  // Identifiant unique
  public id: number;
  // Objet de rattachement
  public objType: ObjTypes;
  // Objet de rattachement
  public objId: number;
  // Fil des échanges
  public items: ChatItem[];
  // 
  public user1: number;
  // 
  public user2: number;
  // 
  public isRead: boolean;
  // 
  public lastMessage: string;
  // 
  public unreadCount: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.objType = ObjTypes.NONE;
    this.objId = 0;
    this.items = [];
    this.user1 = 0;
    this.user2 = 0;
    this.isRead = false;
    this.lastMessage = '';
    this.unreadCount = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Chat): Chat {
    const newChat: Chat = new Chat();
    newChat.id = obj.id;
    newChat.objType = obj.objType;
    newChat.objId = obj.objId;
    newChat.items = JSON.parse(JSON.stringify(obj.items));
    newChat.user1 = obj.user1;
    newChat.user2 = obj.user2;
    newChat.isRead = obj.isRead;
    newChat.lastMessage = obj.lastMessage;
    newChat.unreadCount = obj.unreadCount;
    newChat.createId = obj.createId;
    newChat.failed = obj.failed;
    newChat.canUpdate = obj.canUpdate;
    newChat.canDelete = obj.canDelete;
    newChat.display = obj.display;
    newChat.notifDefType = obj.notifDefType;
    return newChat;
  }

  public toJsonChat (): string {
    const json = {
      objType: this.objType,
      objId: this.objId,
      items: this.items,
      user1: this.user1,
      user2: this.user2,
      isRead: this.isRead,
      lastMessage: this.lastMessage,
      unreadCount: this.unreadCount,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromChat (obj: Chat): void {
    this.id = obj.id;
    this.objType = obj.objType;
    this.objId = obj.objId;
    this.items = obj.items;
    this.user1 = obj.user1;
    this.user2 = obj.user2;
    this.isRead = obj.isRead;
    this.lastMessage = obj.lastMessage;
    this.unreadCount = obj.unreadCount;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareChat (value: Chat): boolean {
    return (this.toJsonChat() == value.toJsonChat());
  }

  public cloneChat (): Chat {
    return Chat.fromJson(this);
  }

  public updateForStoreChat (): Promise<Chat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/chats/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromChat(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public createForStoreChat (): Promise<Chat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/chats/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromChat(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreChat (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/chats/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/chats/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static load (chat: Chat): Promise<Chat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/chats/load', chat, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Chat.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Chats/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Chat.fromJson(listData.reccords[0] as Chat);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Chat> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Chats/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Chat.fromJson(listData.reccords[0] as Chat);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(chats: Chat[]) {
  }
}
